<template>
  <vs-popup :active.sync="active" title="Editar versión" fullscreen>
    <vs-tabs>
      <vs-tab label="Versión">
        <div class="form">
          <vs-input label="Nombre" class="w-full" v-model="version.name"></vs-input>

          <div class="row pt-10 ml-1">
            <vs-button color="dark" :disabled="version.is_published">Publicar</vs-button>
            <vs-button class="ml-2" @click="updateVersion()">Guardar</vs-button>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Grupos e indicadores">

        <template v-if="version">
          <vs-table stripe :data="version.groups">
            <template slot="thead" class="thead-dark">
              <vs-th>Regla</vs-th>
              <vs-th>Peso de la categoría</vs-th>
              <vs-th>Opciones</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(group, index) in data" :key="index">
                <vs-td><strong>{{ group.name }}</strong></vs-td>
                <vs-td>{{ group.weight }}%</vs-td>
                <vs-td>
                  <!-- .btn-add-indicator -->
                  <vs-button @click="addIndicatorDialog(group)">
                    Agregar indicador
                  </vs-button>
                  <!-- .btn-add-indicator -->
                </vs-td>
                <template slot="expand">

                  <div class="con-expand-users w-full">
                    <group-editor-table
                        :group.sync="group"></group-editor-table>
                  </div>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </template>

        <vs-popup
            style="z-index: 540000"
            :title="'Agragar indicador'"
            :active.sync="showGroupEditorVersionDialog">

          <vs-input
              class="w-full"
              v-model="newIndicator.name"
              label="Nombre del indicador"></vs-input>

          <vs-input
              class="w-full"
              v-model="newIndicator.identity_name"
              label="Identificador del indicador"></vs-input>

          <vs-input
              class="w-full"
              v-model="newIndicator.weight"
              label="Peso del indicador"></vs-input>

          <vs-select
              class="w-full"
              label="Tipo de análisis"></vs-select>

          <vs-input
              class="w-full"
              v-model="newIndicator.worst_value"
              label="Limite inferior"></vs-input>

          <vs-input
              class="w-full"
              v-model="newIndicator.best_value"
              label="Limite superior"></vs-input>

          <vs-button @click="save()">Guardar</vs-button>
        </vs-popup>

      </vs-tab>
      <vs-tab label="Ordenamiento">
        <vs-list v-if="version.groups">
          <draggable :list="version.groups[0].rules" class="cursor-move">
            <vs-list-item
                class="flex items-center p-4"
                v-for="(item, index) in version.groups[0].rules"
                :key="index"
                :title="item.name">
            </vs-list-item>
          </draggable>
        </vs-list>

        <vs-button @click="saveOrden()">Guardar ordenamiento</vs-button>
      </vs-tab>
    </vs-tabs>
  </vs-popup>
</template>

<script>
import EditTextComponent from "@components/editText/EditTextComponent";
import {RiskModel} from "@/services/ModelRisk/RiskModel";
import draggable from 'vuedraggable'
import GroupEditorTable from "./GroupEditorTable.vue";

export default {
  name: "VersionEditor",
  components: {GroupEditorTable, EditTextComponent, draggable},
  props: {
    active: {
      type: Boolean,
      required: true
    },
    version: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showGroupEditorVersionDialog: false,
    groupSelected: {},
    newIndicator: {
      name: '',
      identity_name: '',
      weight: 0,
      analysis_type: {
        type: 'PositiveLine',
        argument: ''
      },
      worst_value: 0,
      best_value: 0,
    }
  }),
  methods: {
    addIndicatorDialog(group) {
      this.groupSelected = group;
      this.showGroupEditorVersionDialog = true;
    },
    async updateGroupsAndIndicators(ev) {
      this.$vs.loading();
      try {
        await RiskModel.admin().versions()
            .update(ev.id, ev);
      } catch (e) {
        await swal("Error", e.response.data.error, "error")
        throw e;
      } finally {
        this.$vs.loading.close();
      }
    },
    async save() {
      try {
        this.groupSelected.rules.push(this.newIndicator)
        await this.updateGroupsAndIndicators(this.version)
      } catch (e) {

      }
    },
    async saveOrden() {
      await this.updateGroupsAndIndicators(this.version)
    }
  }
}
</script>

<style scoped>

</style>
